import React from 'react'

import PropTypes from 'prop-types'
import { prop } from 'ramda'
import { useConnect } from 'redux-bundler-hook'

import { idAndNameShape, idPropType } from '~/src/Lib/PropTypes'
import RoomsIcon from '~/src/UI/Icons/Rooms'

import BaseWidget from './Base'

const getName = prop('name')

export const WidgetWhere = props => {
  const { room, zone, title, Icon, ...passthru } = props

  return (
    <BaseWidget
      {...passthru}
      title={[room, zone].filter(Boolean).map(getName).join(', ') || title}
      Icon={Icon}
    />
  )
}
WidgetWhere.propTypes = {
  room: idAndNameShape,
  zone: idAndNameShape,
  Icon: PropTypes.elementType,
  title: PropTypes.node,
}
WidgetWhere.defaultProps = {
  room: null,
  zone: null,
  Icon: RoomsIcon,
  title: 'N/A'
}
WidgetWhere.displayName = 'Widget/Where'

const WidgetWhereWrapper = props => {
  const { room: roomId, zone: zoneId } = props
  const { rooms, zones } = useConnect('selectRooms', 'selectZones')
  const { [roomId]: room } = rooms
  const { [zoneId]: zone } = zones

  return <WidgetWhere {...props} room={room} zone={zone} />
}
WidgetWhereWrapper.propTypes = {
  room: idPropType.nullable,
  zone: idPropType.nullable,
}
WidgetWhereWrapper.defaultProps = {
  zone: null,
  room: null
}

export default React.memo(WidgetWhereWrapper)
